<template lang="pug">
modal#delete-developer-webhook-modal(
  :close-button-label='$t("modal.deleteWebhook.closeButtonLabel")'
  :loading='loading'
  :process-button-label='$t("modal.deleteWebhook.processButtonLabel")'
  :title='$t("modal.deleteWebhook.title")'
  @process='submit'
  processButtonClass='btn-danger'
  ref='modal'
)
  .text-center
    div
      p.text-start {{ $t('modal.deleteWebhook.message1') }}
      p.text-start 
        |
        strong {{ $t('modal.deleteWebhook.message2') }}
      p.text-start {{ $t('modal.deleteWebhook.message3') }}
    img.mt-4.mb-3(
      alt='developer-delete-warning'
      src='/img/ilustrations/developer-delete-warning.svg'
    )
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import Icon from '@/ui/atoms/Icon.vue';
import WebhooksService from '@/services/WebhooksService';
import alert from '@/modules/account/common/alert';

export default {
  name: 'DeleteDeveloperWebhookModal',
  props: {
    uuid: [String],
  },
  components: {
    Modal,
    Icon,
    ImageLoader,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    modalTitle() {
      return this.title;
    },
  },
  methods: {
    submit() {
      this.loading = true;
      WebhooksService.remove(this.uuid)
        .then(() => {
          this.loading = false;
          this.$refs.modal.close();
          this.$emit('refresh');
        })
        .then(() => {
          alert.fireAlert(this.$t('modal.deleteWebhook.successMessage'), {
            classes: 'alert-success',
            styles:
              'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
            icon: 'circle-check',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
